import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PREPAYMENTUSERBALANCEBLOCK_LEGACY_FIELD_ORDER = [
  "shop_entity",
  "heading_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  prepaymentUserBalanceBlockDescriptor: _generatedPrepaymentUserBalanceBlockDescriptor,
  prepaymentUserBalanceBlockBlocDefinition,
  prepaymentUserBalanceBlockDashboardLayout,
  prepaymentUserBalanceBlockConfig,
  prepaymentUserBalanceBlockResolveConfig,
  prepaymentUserBalanceBlockProperties,
} = doodBlockConfig(
  {
    name: "Prepayment User Balance",
    componentType: 'PrepaymentUserBalanceBlockComponent',
    category: 'prepaid',
    description: "Prepayment User Balance.",
    keywords: [],
    allowedIn: [
      { bloc: '*Page', slot: '*' },
    ],
    sharedFields: {}
  },

  () => ({
    shop_entity: propertyValue({
      type: 'shop_picker',
      value: '',
      options: {
        label: "pages.blocks.prepayment-user-balance.shop-entity.label",
        max: 1,
      }
    }),
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.prepayment-user-balance.heading-color.label",
      }
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.prepayment-user-balance.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.prepayment-user-balance.fieldset.shop.label",
            fields: ["shop_entity"],
          },
          {
            legend: "pages.blocks.prepayment-user-balance.fieldset.titles.label",
            fields: ["heading_color"],
          },
        ],
      },
    ],
  })
);

export function prepaymentUserBalanceBlockDescriptor(): IBlockDescriptor;
export function prepaymentUserBalanceBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function prepaymentUserBalanceBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPrepaymentUserBalanceBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPrepaymentUserBalanceBlockDescriptor, prepaymentUserBalanceBlockProperties, fieldOrder);
}

export {
  prepaymentUserBalanceBlockBlocDefinition,
  prepaymentUserBalanceBlockDashboardLayout,
  prepaymentUserBalanceBlockProperties,
  prepaymentUserBalanceBlockConfig,
  prepaymentUserBalanceBlockResolveConfig,
};

export type PrepaymentUserBalanceBlockConfig = typeof prepaymentUserBalanceBlockConfig;
